// Live casino tiles (id → /admin/casino/<id> route, img → icon filename).
// Reference order from tenexch.com — goal2 first. Shared by Home + CasinoList.
export const CASINO_IMG_BASE = 'https://sitethemedata.com/casino_icons/lc'
// Tiles whose CDN art is missing (.webp 404) or stale (.jpg = old "Under
// Maintenance") ship in public/ — same files as the player site's tiles.
const LOCAL_IMG_BASE = '/admin/assets/casino/lc'
export const casinoImgSrc = (item) => `${item.local ? LOCAL_IMG_BASE : CASINO_IMG_BASE}/${item.img}`

export const CASINO_ITEMS = [
  { id: 'goal2', img: 'goal2.jpg', cat: 'Sports' },
  { id: 'worli3', img: 'worli3.webp', local: true, cat: 'Worli' },
  { id: 'teen62', img: 'teen62.webp', local: true, cat: 'Teenpatti' },
  { id: 'dolidana', img: 'dolidana.webp', local: true, cat: 'Others' },
  { id: 'mogambo', img: 'mogambo.webp', local: true, cat: 'Others' },
  { id: 'lucky5', img: 'lucky5.jpg', cat: 'Lucky 7' },
  { id: 'roulette12', img: 'roulette12.jpg', cat: 'Roulette' },
  { id: 'roulette13', img: 'roulette13.jpg', cat: 'Roulette' },
  { id: 'roulette11', img: 'roulette11.jpg', cat: 'Roulette' },
  { id: 'poison', img: 'poison.jpg', cat: 'Teenpatti' },
  { id: 'teenunique', img: 'teenunique.jpg', cat: 'Teenpatti' },
  { id: 'poisonteenpatti20', img: 'poison20.jpg', cat: 'Teenpatti' },
  { id: 'jokerteenpatti120', img: 'joker120.jpg', cat: 'Teenpatti' },
  { id: 'jokerteenpatti20', img: 'joker20.jpg', cat: 'Teenpatti' },
  { id: 'jokerteenpatti1', img: 'joker1.jpg', cat: 'Teenpatti' },
  { id: 'teenpattit20c', img: 'teen20c.jpg', cat: 'Teenpatti' },
  { id: 'bollywoodtable2', img: 'btable2.jpg', cat: 'Bollywood' },
  { id: 'ourroullete', img: 'ourroullete.jpg', cat: 'Roulette' },
  { id: 'superover3', img: 'superover3.jpg', cat: 'Sports' },
  { id: 'goal', img: 'goal.jpg', cat: 'Sports' },
  { id: 'ab4', img: 'ab4.jpg', cat: 'Andar Bahar' },
  { id: 'lucky15', img: 'lucky15.jpg', cat: 'Lucky 7' },
  { id: 'superover2', img: 'superover2.jpg', cat: 'Sports' },
  { id: 'teenpatti41', img: 'teen41.jpg', cat: 'Teenpatti' },
  { id: 'teenpatti42', img: 'teen42.jpg', cat: 'Teenpatti' },
  { id: 'sicbo2', img: 'sicbo2.jpg', cat: 'Others' },
  { id: 'teenpattiinstant3', img: 'teen33.jpg', cat: 'Teenpatti' },
  { id: 'sicbo', img: 'sicbo.jpg', cat: 'Others' },
  { id: 'ballbyball', img: 'ballbyball.jpg', cat: 'Sports' },
  { id: 'teenpattiinstant2', img: 'teen32.jpg', cat: 'Teenpatti' },
  { id: 'teenpattioneday', img: 'teen.jpg', cat: 'Teenpatti' },
  { id: 'teenpattit20', img: 'teen20.jpg', cat: 'Teenpatti' },
  { id: 'teenpattitest', img: 'teen9.jpg', cat: 'Teenpatti' },
  { id: 'teenpattiopen', img: 'teen8.jpg', cat: 'Teenpatti' },
  { id: 'pokeroneday', img: 'poker.jpg', cat: 'Poker' },
  { id: 'poker20', img: 'poker20.jpg', cat: 'Poker' },
  { id: 'poker6player', img: 'poker6.jpg', cat: 'Poker' },
  { id: 'baccarat', img: 'baccarat.jpg', cat: 'Baccarat' },
  { id: 'baccarat2', img: 'baccarat2.jpg', cat: 'Baccarat' },
  { id: 'dragontigert20', img: 'dt20.jpg', cat: 'Dragon Tiger' },
  { id: 'dragontigeroneday', img: 'dt6.jpg', cat: 'Dragon Tiger' },
  { id: 'dragontigerliont20', img: 'dtl20.jpg', cat: 'Dragon Tiger' },
  { id: 'dragontigert202', img: 'dt202.jpg', cat: 'Dragon Tiger' },
  { id: 'card32a', img: 'card32.jpg', cat: '32 Cards' },
  { id: 'card32b', img: 'card32eu.jpg', cat: '32 Cards' },
  { id: 'andar-bahar', img: 'ab20.jpg', cat: 'Andar Bahar' },
  { id: 'andar-bahar2', img: 'abj.jpg', cat: 'Andar Bahar' },
  { id: 'lucky7', img: 'lucky7.jpg', cat: 'Lucky 7' },
  { id: 'lucky7eu', img: 'lucky7eu.jpg', cat: 'Lucky 7' },
  { id: '3cardj', img: '3cardj.jpg', cat: '3 Card Judgement' },
  { id: 'war', img: 'war.jpg', cat: 'Casino War' },
  { id: 'worli', img: 'worli.jpg', cat: 'Worli' },
  { id: 'instantworli', img: 'worli2.jpg', cat: 'Worli' },
  { id: 'aaa', img: 'aaa.jpg', cat: 'Others' },
  { id: 'bollywoodtable', img: 'btable.jpg', cat: 'Bollywood' },
  { id: 'lottery', img: 'lottcard.jpg', cat: 'Lottery' },
  { id: 'cricketv3', img: 'cricketv3.jpg', cat: 'Sports' },
  { id: 'cmatch20', img: 'cmatch20.jpg', cat: 'Sports' },
  { id: 'meter', img: 'cmeter.jpg', cat: 'Others' },
  { id: 'teenpatti2', img: 'teen6.jpg', cat: 'Teenpatti' },
  { id: 'queen', img: 'queen.jpg', cat: 'Queen' },
  { id: 'race20', img: 'race20.jpg', cat: 'Race' },
  { id: 'lucky7eu2', img: 'lucky7eu2.jpg', cat: 'Lucky 7' },
  { id: 'superover', img: 'superover.jpg', cat: 'Sports' },
  { id: 'trap', img: 'trap.jpg', cat: 'Others' },
  { id: 'teenpatti2cards', img: 'patti2.jpg', cat: 'Teenpatti' },
  { id: '29cardbaccarat', img: 'teensin.jpg', cat: 'Baccarat' },
  { id: 'teenmuf', img: 'teenmuf.jpg', cat: 'Teenpatti' },
  { id: 'raceto17', img: 'race17.jpg', cat: 'Race' },
  { id: 'teenpattit20b', img: 'teen20b.jpg', cat: 'Teenpatti' },
  { id: 'trio', img: 'trio.jpg', cat: 'Others' },
  { id: 'notenum', img: 'notenum.jpg', cat: 'Others' },
  { id: '1card2020', img: 'teen120.jpg', cat: 'Teenpatti' },
  { id: '1card1day', img: 'teen1.jpg', cat: 'Teenpatti' },
  { id: 'ab3', img: 'ab3.jpg', cat: 'Andar Bahar' },
  { id: 'aaa2', img: 'aaa2.jpg', cat: 'Others' },
  { id: 'race2', img: 'race2.jpg', cat: 'Race' },
  { id: 'teenpattiinstant', img: 'teen3.jpg', cat: 'Teenpatti' },
  { id: 'dum10', img: 'dum10.jpg', cat: 'Others' },
  { id: 'cmeter1', img: 'cmeter1.jpg', cat: 'Others' },
]
